export default {
  cafelandMobileCms: {
    title: 'Cafeland Mobile CMS',
    link: 'https://cafeland.cms.gamegos.net',
  },
  cafelandMobileCmsBeta: {
    title: 'Cafeland Mobile Beta CMS',
    link: 'https://cafeland.beta.cms.gamegos.net',
  },
  cafelandMobilePanelAnalytics: {
    title: 'Cafeland Mobile Analytics (Panel)',
    link: 'https://panel.gamegos.net/#/apps/cal/all/dashboard',
  },
  cafelandMobilePanelAnalyticsBeta: {
    title: 'Cafeland Mobile Beta Analytics (Panel)',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/cal_mas/all/dashboard',
  },
  cafelandMobileSupport: {
    title: 'Cafeland Mobile Support',
    link: 'https://support.gamegos.net/cal',
  },
  cafelandMobileSupportBetaMaster: {
    title: 'Cafeland Mobile Support',
    link: 'https://support-beta.gamegos.net/cal_mas',
  },
  cafelandMobileSupportDashboard: {
    title: 'Cafeland Mobile Support',
    link: 'https://support.gamegos.net/cal/dashboard',
  },
  cafelandMobileSupportUsers: {
    title: 'Cafeland Mobile Support Users',
    link: 'https://support.gamegos.net/cal/users',
  },
  cafelandMobileSupportLogs: {
    title: 'Cafeland Mobile Support Logs',
    link: 'https://support.gamegos.net/cal/logs/access',
  },
  cafelandMobileSupportPayment: {
    title: 'Cafeland Mobile Support Payment',
    link: 'https://support.gamegos.net/cal/payment/packages',
  },
  cafelandMobileSupportCompensation: {
    title: 'Cafeland Mobile Support Compensation',
    link: 'https://support.gamegos.net/cal/compensation',
  },
  cafelandMobileSupportManagement: {
    title: 'Cafeland Mobile Support Management',
    link: 'https://support.gamegos.net/cal/management/activitylogs',
  },
  cafelandMobileManagement: {
    title: 'Cafeland Mobile Management',
    link: 'https://management.gamegos.net/cal',
  },
  cafelandMobileManagementBetaMaster: {
    title: 'Cafeland Mobile Management Beta Master',
    link: 'https://management-beta.gamegos.net/cal_mas',
  },
  cafelandMobileManagementManagement: {
    title: 'Cafeland Mobile Management Management',
    link: 'https://management.gamegos.net/cal/management/clients',
  },
  cafelandMobileManagementClan: {
    title: 'Cafeland Mobile Management Clan',
    link: 'https://management.gamegos.net/cal/clan/seasons',
  },
  cafelandMobileManagementDefinitions: {
    title: 'Cafeland Mobile Management Definitions',
    link: 'https://management.gamegos.net/cal/definitions/customdata',
  },
  cafelandMobileManagementOthers: {
    title: 'Cafeland Mobile Management Others',
    link: 'https://management.gamegos.net/cal/others/activitylogs',
  },
  cafelandMobileFacebookDashboard: {
    title: 'Cafeland Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/1522990077998990/dashboard',
  },
  cafelandMobileFacebookRoles: {
    title: 'Cafeland Facebook Roles',
    link: 'https://developers.facebook.com/apps/1522990077998990/roles/roles',
  },
  cafelandMobileAppStore: {
    title: 'Cafeland Mobile App Store',
    link: 'https://itunes.apple.com/us/app/cafeland-world-kitchen/id1147665432?mt=8',
  },
  cafelandMobilePlayStore: {
    title: 'Cafeland Mobile Play Store',
    link: 'https://play.google.com/store/apps/details?id=com.gamegos.mobile.cafeland',
    keywords: ['Google'],
  },
  cafelandMobileZendesk: {
    title: 'Cafeland Mobile Zendesk',
    link: 'https://cafeland.zendesk.com/hc/en-us',
  },
  cafelandMobileFacebookPage: {
    title: 'Cafeland Mobile Facebook Page',
    link: 'https://www.facebook.com/cafelandgame/',
  },
  manorCafeCms: {
    title: 'Manor Cafe CMS',
    link: 'https://manorcafe.cms.gamegos.net/',
  },
  manorCafeCmsBeta: {
    title: 'Manor Cafe Beta CMS',
    link: 'https://manorcafe.beta.cms.gamegos.net/',
  },
  manorCafePanelAnalytics: {
    title: 'Manor Cafe Analytics (Panel)',
    link: 'https://panel.gamegos.net/#/apps/man/all/dashboard',
  },
  manorCafePanelAnalyticsBeta: {
    title: 'Manor Cafe Beta Analytics (Panel)',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/man_mas/all/dashboard',
  },
  manorCafeSupport: {
    title: 'Manor Cafe Support',
    link: 'https://support.gamegos.net/man',
  },
  manorCafeSupportBetaMaster: {
    title: 'Manor Cafe Master Beta Support',
    link: 'https://support-beta.gamegos.net/man_mas',
  },
  manorCafeSupportBetaLevel: {
    title: 'Manor Cafe Level Beta Support',
    link: 'https://support-beta.gamegos.net/man_lev',
  },
  manorCafeSupportDashboard: {
    title: 'Manor Cafe Support',
    link: 'https://support.gamegos.net/man/dashboard',
  },
  manorCafeSupportUsers: {
    title: 'Manor Cafe Support Users',
    link: 'https://support.gamegos.net/man/users',
  },
  manorCafeSupportLogs: {
    title: 'Manor Cafe Support Logs',
    link: 'https://support.gamegos.net/man/logs/access',
  },
  manorCafeSupportPayment: {
    title: 'Manor Cafe Support Payment',
    link: 'https://support.gamegos.net/man/payment/packages',
  },
  manorCafeSupportCompensation: {
    title: 'Manor Cafe Support Compensation',
    link: 'https://support.gamegos.net/man/compensation',
  },
  manorCafeSupportManagement: {
    title: 'Manor Cafe Support Management',
    link: 'https://support.gamegos.net/man/management/activitylogs',
  },
  manorCafeManagement: {
    title: 'Manor Cafe Management',
    link: 'https://management.gamegos.net/man',
  },
  manorCafeManagementBetaMaster: {
    title: 'Manor Cafe Management Beta Master',
    link: 'https://management-beta.gamegos.net/man_mas',
  },
  manorCafeManagementBetaLevel: {
    title: 'Manor Cafe Management Beta Level',
    link: 'https://management-beta.gamegos.net/man_lev',
  },
  manorCafeManagementManagement: {
    title: 'Manor Cafe Management Management',
    link: 'https://management.gamegos.net/man/management/clients',
  },
  manorCafeManagementClan: {
    title: 'Manor Cafe Management Clan',
    link: 'https://management.gamegos.net/man/clan/seasons',
  },
  manorCafeManagementDefinitions: {
    title: 'Manor Cafe Management Definitions',
    link: 'https://management.gamegos.net/man/definitions/customdata',
  },
  manorCafeManagementOthers: {
    title: 'Manor Cafe Management Others',
    link: 'https://management.gamegos.net/man/others/activitylogs',
  },
  manorCafeFacebookDashboard: {
    title: 'Manor Cafe Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/557754851261640/dashboard',
  },
  manorCafeFacebookRoles: {
    title: 'Manor Cafe Facebook Roles',
    link: 'https://developers.facebook.com/apps/557754851261640/roles/roles',
  },
  manorCafeAppStore: {
    title: 'Manor Cafe App Store',
    link: 'https://itunes.apple.com/tr/app/manor-cafe/id1358742711?mt=8',
  },
  manorCafePlayStore: {
    title: 'Manor Cafe Play Store',
    link: 'https://play.google.com/store/apps/details?id=com.gamegos.mobile.manorcafe',
    keywords: ['Google'],
  },
  manorCafeZendesk: {
    title: 'Manor Cafe Zendesk',
    link: 'https://manorcafe.zendesk.com/hc/en-us',
  },
  manorCafeFacebookPage: {
    title: 'Manor Cafe Facebook Page',
    link: 'https://www.facebook.com/manorcafegame',
  },
  adventureBayCms: {
    title: 'Adventure Bay CMS',
    link: 'https://adventurebay.cms.gamegos.net',
  },
  adventureBayCmsBeta: {
    title: 'Adventure Bay Beta CMS',
    link: 'https://adventurebay.beta.cms.gamegos.net',
  },
  adventureBayCmsQuestBeta: {
    title: 'Adventure Bay Quest Beta CMS',
    link: 'https://adventurebay-quest.beta.cms.gamegos.net/',
  },
  adventureBayPanelAnalytics: {
    title: 'Adventure Bay Analytics (Panel)',
    link: 'https://panel.gamegos.net/#/apps/adv/all/dashboard',
  },
  adventureBayPanelAnalyticsBeta: {
    title: 'Adventure Bay Beta Analytics (Panel)',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/adv_mas/all/dashboard',
  },
  adventureBaySupport: {
    title: 'Adventure Bay Support',
    link: 'https://support.gamegos.net/adv',
  },
  adventureBaySupportBetaMaster: {
    title: 'Adventure Bay Master Beta Support',
    link: 'https://support-beta.gamegos.net/adv_mas',
  },
  adventureBaySupportDashboard: {
    title: 'Adventure Bay Support',
    link: 'https://support.gamegos.net/adv/dashboard',
  },
  adventureBaySupportUsers: {
    title: 'Adventure Bay Support Users',
    link: 'https://support.gamegos.net/adv/users',
  },
  adventureBaySupportLogs: {
    title: 'Adventure Bay Support Logs',
    link: 'https://support.gamegos.net/adv/logs/access',
  },
  adventureBaySupportPayment: {
    title: 'Adventure Bay Support Payment',
    link: 'https://support.gamegos.net/adv/payment/packages',
  },
  adventureBaySupportCompensation: {
    title: 'Adventure Bay Support Compensation',
    link: 'https://support.gamegos.net/adv/compensation',
  },
  adventureBaySupportManagement: {
    title: 'Adventure Bay Support Management',
    link: 'https://support.gamegos.net/adv/management/activitylogs',
  },
  adventureBayManagement: {
    title: 'Adventure Bay Management',
    link: 'https://management.gamegos.net/adv',
  },
  adventureBayManagementBetaMaster: {
    title: 'Adventure Bay Management Beta Master',
    link: 'https://management-beta.gamegos.net/adv_mas',
  },
  adventureBayManagementManagement: {
    title: 'Adventure Bay Management Management',
    link: 'https://management.gamegos.net/adv/management/clients',
  },
  adventureBayManagementClan: {
    title: 'Adventure Bay Management Clan',
    link: 'https://management.gamegos.net/adv/clan/seasons',
  },
  adventureBayManagementDefinitions: {
    title: 'Adventure Bay Management Definitions',
    link: 'https://management.gamegos.net/adv/definitions/customdata',
  },
  adventureBayManagementOthers: {
    title: 'Adventure Bay Management Others',
    link: 'https://management.gamegos.net/adv/others/activitylogs',
  },
  adventureBayAppStore: {
    title: 'Adventure Bay App Store',
    link: 'https://apps.apple.com/app/adventure-bay-paradise-farm/id1578449819?l=en',
  },
  adventureBayPlayStore: {
    title: 'Adventure Bay Play Store',
    link: 'https://play.google.com/store/apps/details?id=com.gamegos.adventure.bay.paradise.farm&hl=en&gl=US',
    keywords: ['Google'],
  },
  adventureBayZendesk: {
    title: 'Adventure Bay Zendesk',
    link: 'https://adventurebay.zendesk.com/hc/en-us',
  },
  adventureBayFacebookPage: {
    title: 'Adventure Bay Facebook Page',
    link: 'https://www.facebook.com/adventurebaygame',
  },
  cookingTaleCms: {
    title: 'Cooking Tale CMS',
    link: 'https://cookingtale.cms.gamegos.net',
  },
  cookingTaleCmsBeta: {
    title: 'Cooking Tale CMS Beta',
    link: 'https://cookingtale.beta.cms.gamegos.net',
  },
  cookingTaleAnalytics: {
    title: 'Cooking Tale Analytics',
    link: 'https://panel.gamegos.net/#/apps/coo/all/dashboard',
  },
  cookingTaleAnalyticsBeta: {
    title: 'Cooking Tale Beta Analytics',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/coo_mas/all/dashboard',
  },
  cookingTaleSupport: {
    title: 'Cooking Tale Support',
    link: 'https://support.gamegos.net/coo',
  },
  cookingTaleSupportBetaMaster: {
    title: 'Cooking Tale Master Beta Support',
    link: 'https://support-beta.gamegos.net/coo_mas',
  },
  cookingTaleSupportDashboard: {
    title: 'Cooking Tale Support',
    link: 'https://support.gamegos.net/coo/dashboard',
  },
  cookingTaleSupportUsers: {
    title: 'Cooking Tale Support Users',
    link: 'https://support.gamegos.net/coo/users',
  },
  cookingTaleSupportLogs: {
    title: 'Cooking Tale Support Logs',
    link: 'https://support.gamegos.net/coo/logs/access',
  },
  cookingTaleSupportPayment: {
    title: 'Cooking Tale Support Payment',
    link: 'https://support.gamegos.net/coo/payment/packages',
  },
  cookingTaleSupportCompensation: {
    title: 'Cooking Tale Support Compensation',
    link: 'https://support.gamegos.net/coo/compensation',
  },
  cookingTaleSupportManagement: {
    title: 'Cooking Tale Support Management',
    link: 'https://support.gamegos.net/coo/management/activitylogs',
  },
  cookingTaleManagement: {
    title: 'Cooking Tale Management',
    link: 'https://management.gamegos.net/coo',
  },
  cookingTaleManagementBetaMaster: {
    title: 'Cooking Tale Management Beta Master',
    link: 'https://management-beta.gamegos.net/coo_mas',
  },
  cookingTaleManagementManagement: {
    title: 'Cooking Tale Management Management',
    link: 'https://management.gamegos.net/coo/management/clients',
  },
  cookingTaleManagementDefinitions: {
    title: 'Cooking Tale Management Definitions',
    link: 'https://management.gamegos.net/coo/definitions/customdata',
  },
  cookingTaleManagementOthers: {
    title: 'Cooking Tale Management Others',
    link: 'https://management.gamegos.net/coo/others/activitylogs',
  },
  cookingTaleFacebookDashboard: {
    title: 'Cooking Tale Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/187657708100125/dashboard/?business_id=839522159410339',
  },
  cookingTaleFacebookDashboardBeta: {
    title: 'Cooking Tale Beta Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/1210050339169883/dashboard/',
  },
  cookingTaleAppStore: {
    title: 'Cooking Tale App Store',
    link: 'https://apps.apple.com/us/app/cooking-tale/id1069899666?ls=1',
  },
  cookingTalePlayStore: {
    title: 'Cooking Tale Play Store',
    link: 'https://play.google.com/store/apps/details?id=air.com.gamegos.mobile.cookingtale&hl=en',
    keywords: ['Google'],
  },
  cookingTaleFreshdesk: {
    title: 'Cooking Tale Freshdesk',
    link: 'https://cookingtale-support.gamegos.net/support/home',
  },
  cookingTaleFacebookPage: {
    title: 'Cooking Tale Facebook Page',
    link: 'https://www.facebook.com/cookingtalegame',
  },
  fashionCupCMS: {
    title: 'Fashion Cup CMS',
    link: 'https://fashcup.cms.gamegos.net',
  },
  fashionCupCMSBeta: {
    title: 'Fashion Cup Beta CMS',
    link: 'https://fashcup.beta.cms.gamegos.net',
  },
  fashionCupAnalytics: {
    title: 'Fashion Cup Analytics',
    link: 'https://panel.gamegos.net/#/apps/fah/all/dashboard',
  },
  fashionCupAnalyticsBeta: {
    title: 'Fashion Cup Beta Analytics',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/fah_mas/all/dashboard',
  },
  fashionCupSupport: {
    title: 'Fashion Cup Support',
    link: 'https://support.gamegos.net/fah',
  },
  fashionCupSupportBetaMaster: {
    title: 'Fashion Cup Master Beta Support',
    link: 'https://support-beta.gamegos.net/fah_mas',
  },
  fashionCupSupportDashboard: {
    title: 'Fashion Cup Support',
    link: 'https://support.gamegos.net/fah/dashboard',
  },
  fashionCupSupportUsers: {
    title: 'Fashion Cup Support Users',
    link: 'https://support.gamegos.net/fah/users',
  },
  fashionCupSupportLogs: {
    title: 'Fashion Cup Support Logs',
    link: 'https://support.gamegos.net/fah/logs/access',
  },
  fashionCupSupportPayment: {
    title: 'Fashion Cup Support Payment',
    link: 'https://support.gamegos.net/fah/payment/packages',
  },
  fashionCupSupportCompensation: {
    title: 'Fashion Cup Support Compensation',
    link: 'https://support.gamegos.net/fah/compensation',
  },
  fashionCupSupportManagement: {
    title: 'Fashion Cup Support Management',
    link: 'https://support.gamegos.net/fah/management/activitylogs',
  },
  fashionCupManagement: {
    title: 'Fashion Cup Management',
    link: 'https://management.gamegos.net/fah',
  },
  fashionCupManagementBetaMaster: {
    title: 'Fashion Cup Management Beta Master',
    link: 'https://management-beta.gamegos.net/fah_mas',
  },
  fashionCupManagementManagement: {
    title: 'Fashion Cup Management Management',
    link: 'https://management.gamegos.net/fah/management/clients',
  },
  fashionCupManagementDefinitions: {
    title: 'Fashion Cup Management Definitions',
    link: 'https://management.gamegos.net/fah/definitions/customdata',
  },
  fashionCupManagementOthers: {
    title: 'Fashion Cup Management Others',
    link: 'https://management.gamegos.net/fah/others/activitylogs',
  },
  fashionCupAppStore: {
    title: 'Fashion Cup App Store',
    link: 'https://apps.apple.com/us/app/fashion-cup/id1045500458?ls=1',
  },
  fashionCupPlayStore: {
    title: 'Fashion Cup Play Store',
    link: 'https://play.google.com/store/apps/details?id=air.com.gamegos.mobile.fashcup',
    keywords: ['Google'],
  },
  fashionCupFacebookPage: {
    title: 'Fashion Cup Facebook Page',
    link: 'https://www.facebook.com/fashioncupgame/',
  },
  fashionCupFreshdesk: {
    title: 'Fashion Cup Freshdesk',
    link: 'https://gamegos.freshdesk.com/support/discussions/5000075822',
  },
  solitaireCms: {
    title: 'Solitaire Story CMS',
    link: 'https://solitale.gamegos.net/gosman',
  },
  solitaireAnalytics: {
    title: 'Solitaire Story Analytics',
    link: 'https://panel.gamegos.net/#/apps/sol/all/dashboard',
  },
  solitaireAnalyticsBeta: {
    title: 'Solitaire Story Beta Analytics',
    link: 'https://mamut-panel-beta.gamegos.net/#/apps/sol_mas/all/dashboard?globalFilters=%7B%7D',
  },
  solitaireSupport: {
    title: 'Solitaire Story Support',
    link: 'https://support.gamegos.net/sol',
  },
  solitaireSupportBetaMaster: {
    title: 'Solitaire Story Master Beta Support',
    link: 'https://support-beta.gamegos.net/sol_mas',
  },
  solitaireSupportDashboard: {
    title: 'Solitaire Story Support',
    link: 'https://support.gamegos.net/sol/dashboard',
  },
  solitaireSupportUsers: {
    title: 'Solitaire Story Support Users',
    link: 'https://support.gamegos.net/sol/users',
  },
  solitaireSupportLogs: {
    title: 'Solitaire Story Support Logs',
    link: 'https://support.gamegos.net/sol/logs/access',
  },
  solitaireSupportPayment: {
    title: 'Solitaire Story Support Payment',
    link: 'https://support.gamegos.net/sol/payment/packages',
  },
  solitaireSupportCompensation: {
    title: 'Solitaire Story Support Compensation',
    link: 'https://support.gamegos.net/sol/compensation',
  },
  solitaireSupportManagement: {
    title: 'Solitaire Story Support Management',
    link: 'https://support.gamegos.net/sol/management/activitylogs',
  },
  solitaireManagement: {
    title: 'Solitaire Story Management',
    link: 'https://management.gamegos.net/sol',
  },
  solitaireManagementBetaMaster: {
    title: 'Solitaire Story Management Beta Master',
    link: 'https://management-beta.gamegos.net/sol_mas',
  },
  solitaireManagementManagement: {
    title: 'Solitaire Story Management Management',
    link: 'https://management.gamegos.net/sol/management/clients',
  },
  solitaireManagementDefinitions: {
    title: 'Solitaire Story Management Definitions',
    link: 'https://management.gamegos.net/sol/definitions/customdata',
  },
  solitaireManagementOthers: {
    title: 'Solitaire Story Management Others',
    link: 'https://management.gamegos.net/sol/others/activitylogs',
  },
  solitaireFacebookDashboard: {
    title: 'Solitaire Story Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/566232573433393/dashboard/?business_id=839522159410339',
  },
  solitaireFacebookDashboardBeta: {
    title: 'Solitaire Story Beta Facebook Dashboard',
    link: 'https://developers.facebook.com/apps/436629100487804/dashboard/',
  },
  solitaireAppStore: {
    title: 'Solitaire Story App Store',
    link: 'https://apps.apple.com/us/app/solitaire-story/id946861672',
  },
  solitairePlayStore: {
    title: 'Solitaire Story Play Store',
    link: 'https://play.google.com/store/apps/details?id=air.com.gamegos.solitale&hl=en',
    keywords: ['Google'],
  },
  solitaireFacebookPage: {
    title: 'Solitaire Story Facebook Page',
    link: 'https://www.facebook.com/solitalegame',
  },
  solitaireFreshdesk: {
    title: 'Solitaire Story Facebook Page',
    link: 'https://solitale-support.gamegos.net/support/home',
  },
  solitaireTwitter: {
    title: 'Solitaire Story Twitter',
    link: 'https://twitter.com/solitaire_story',
  },
  videoJigsawPuzzleManagement: {
    title: 'Video Jigsaw Puzzle Management',
    link: 'https://management.gamegos.net/vjs',
  },
  videoJigsawPuzzleManagementBetaMaster: {
    title: 'Video Jigsaw Puzzle Management Beta Master',
    link: 'https://management-beta.gamegos.net/vjs_mas',
  },
  videoJigsawPuzzleManagementManagement: {
    title: 'Video Jigsaw Puzzle Management Management',
    link: 'https://management.gamegos.net/vjs/management/clients',
  },
  videoJigsawPuzzleManagementDefinitions: {
    title: 'Video Jigsaw Puzzle Management Definitions',
    link: 'https://management.gamegos.net/vjs/definitions/customdata',
  },
  videoJigsawPuzzleManagementOthers: {
    title: 'Video Jigsaw Puzzle Management Others',
    link: 'https://management.gamegos.net/vjs/others/activitylogs',
  },
  videoJigsawPuzzleSupport: {
    title: 'Video Jigsaw Puzzle Support',
    link: 'https://support.gamegos.net/vjs',
  },
  videoJigsawPuzzleSupportBetaMaster: {
    title: 'Video Jigsaw Puzzle Master Beta Support',
    link: 'https://support-beta.gamegos.net/vjs_mas',
  },
  videoJigsawPuzzleSupportBetaLevel: {
    title: 'Video Jigsaw Puzzle Level Beta Support',
    link: 'https://support-beta.gamegos.net/vjs_lev',
  },
  videoJigsawPuzzleSupportDashboard: {
    title: 'Video Jigsaw Puzzle Support',
    link: 'https://support.gamegos.net/vjs/dashboard',
  },
  videoJigsawPuzzleSupportUsers: {
    title: 'Video Jigsaw Puzzle Support Users',
    link: 'https://support.gamegos.net/vjs/users',
  },
  videoJigsawPuzzleSupportLogs: {
    title: 'Video Jigsaw Puzzle Support Logs',
    link: 'https://support.gamegos.net/vjs/logs/access',
  },
  videoJigsawPuzzleSupportPayment: {
    title: 'Video Jigsaw Puzzle Support Payment',
    link: 'https://support.gamegos.net/vjs/payment/packages',
  },
  videoJigsawPuzzleSupportCompensation: {
    title: 'Video Jigsaw Puzzle Support Compensation',
    link: 'https://support.gamegos.net/vjs/compensation',
  },
  videoJigsawPuzzleSupportManagement: {
    title: 'Video Jigsaw Puzzle Support Management',
    link: 'https://support.gamegos.net/vjs/management/activitylogs',
  },
  videoJigsawPuzzleAppStore: {
    title: 'Video Jigsaw Puzzle App Store',
    link: 'https://apps.apple.com/us/app/video-jigsaw-puzzle/id6759909743'
  },
  videoJigsawPuzzlePlayStore: {
    title: 'Video Jigsaw Puzzle Play Store',
    link: 'https://play.google.com/store/apps/details?id=com.gamegos.videojigsawpuzzles&hl=en',
    keywords: ['Google'],
  },
  videoJigsawPuzzleFacebookPage: {
    title: 'Video Jigsaw Puzzle Facebook Page',
    link: 'https://www.facebook.com/profile.php?id=61579471577051',
  },
  puzzlePaintManagement: {
    title: 'Puzzle Paint Management',
    link: 'https://management.gamegos.net/pzp',
  },
  puzzlePaintManagementBetaMaster: {
    title: 'Puzzle Paint Management Beta Master',
    link: 'https://management-beta.gamegos.net/pzp_mas',
  },
  puzzlePaintSupport: {
    title: 'Puzzle Paint Support',
    link: 'https://support.gamegos.net/pzp',
  },
  puzzlePaintSupportBetaMaster: {
    title: 'Puzzle Paint Master Beta Support',
    link: 'https://support-beta.gamegos.net/pzp_mas',
  },
  puzzlePaintCatalog: {
    title: 'Puzzle Paint Catalog',
    link: 'http://192.168.1.35:3005',
    keywords: ['Catalog', 'internal'],
  },
  puzzlePaintAppStore: {
    title: 'Puzzle Paint App Store',
    link: 'https://apps.apple.com/us/app/picture-puzzles/id6760467451'
  },
  puzzlePaintPlayStore: {
    title: 'Puzzle Paint Play Store',
    link: 'https://play.google.com/store/apps/details?id=com.gamegos.picturepuzzle&hl=en',
    keywords: ['Google'],
  },
  puzzlePaintFacebookPage: {
    title: 'Puzzle Paint Facebook Page',
    link: 'https://www.facebook.com/profile.php?id=61592879381278',
  },
  puzzlePaintSlackGame: {
    title: 'Puzzle Paint Slack Game Channel',
    link: 'https://gamegos.slack.com/archives/C0B1ALR623H',
  },
  manorCafeSlackGame: {
    title: 'Manor Cafe Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C7A5W37DE',
  },
  cafelandMobileSlackGame: {
    title: 'Cafeland Mobile Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C5KPR7XPW',
  },
  adventureBaySlackGame: {
    title: 'Adventure Bay Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C01R8ED37N3',
  },
  solitaireStorySlackGame: {
    title: 'Solitaire Story Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C5LGGV68N',
  },
  fashionCupSlackGame: {
    title: 'Fashion Cup Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C5KL12L2X',
  },
  cookingTaleSlackGame: {
    title: 'Cooking Tale Slack Game Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C5KQZ73K7',
  },
  videoJigsawPuzzleSlackGame: {
    title: 'Video Jigsaw Puzzle Slack Game Channel',
    link: 'https://gamegos.slack.com/archives/C0AAZ9AP459',
  },
  gamegosSharedGoogleDrive: {
    title: 'Shared GAMEGOS Google Drive Folder',
    link: 'https://drive.google.com/drive/folders/0BxV42KpKlRgtbVBfOFlvRmdmN28',
  },
  manorCafeSlackFeed: {
    title: 'Manor Cafe Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C9TAFU5SP',
  },
  cafelandMobileSlackFeed: {
    title: 'Cafeland Mobile Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C69EQKXCY',
  },
  adventureBaySlackFeed: {
    title: 'Adventure Bay Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C025CGKDMF1',
  },
  solitaireStorySlackFeed: {
    title: 'Solitaire Story Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C6B1BTF2S',
  },
  fashionCupSlackFeed: {
    title: 'Fashion Cup Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C6A4JHSSE',
  },
  cookingTaleSlackFeed: {
    title: 'Cooking Tale Slack Feed Channel',
    link: 'https://app.slack.com/client/T02KSJA6F/C6A4JBQ10',
  },
  manorCafeBoosterReport: {
    title: 'Manor Cafe Booster Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/booster',
  },
  cafelandMobileBoosterReport: {
    title: 'Cafeland Mobile Booster Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/booster',
  },
  adventureBayBoosterReport: {
    title: 'AdventureBay Booster Report',
    link: 'https://panel.gamegos.net/#/apps/adv/all/reports/booster',
  },
  cookingTaleBoosterReport: {
    title: 'Cooking Tale Booster Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/booster',
  },
  fashionCupBoosterReport: {
    title: 'Fashion Cup Booster Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/booster',
  },
  solitaireStoryBoosterReport: {
    title: 'Solitaire Story Booster Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/booster',
  },
  manorCafeCOINUsageReport: {
    title: 'Manor Cafe COIN Usage Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/currency',
  },
  cafelandMobileCOINUsageReport: {
    title: 'Cafeland Mobile COIN Usage Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/currency',
  },
  cookingTaleCOINUsageReport: {
    title: 'Cooking Tale COIN Usage Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/currency',
  },
  fashionCupCOINUsageReport: {
    title: 'Fashion Cup COIN Usage Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/currency',
  },
  solitaireStoryCOINUsageReport: {
    title: 'Solitaire Story COIN Usage Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/currency',
  },
  manorCafeEventProgressReport: {
    title: 'Manor Cafe Event Progress Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/event/',
  },
  cafelandMobileEventProgressReport: {
    title: 'Cafeland Mobile Event Progress Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/event/',
  },
  cookingTaleEventProgressReport: {
    title: 'Cooking Tale Event Progress Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/event/',
  },
  fashionCupEventProgressReport: {
    title: 'Fashion Cup Event Progress Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/event/',
  },
  solitaireStoryEventProgressReport: {
    title: 'Solitaire Story Event Progress Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/event/',
  },
  manorCafeFunnelReport: {
    title: 'Manor Cafe Funnel Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/funnel/',
  },
  cafelandMobileFunnelReport: {
    title: 'Cafeland Mobile Funnel Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/funnel/',
  },
  cookingTaleFunnelReport: {
    title: 'Cooking Tale Funnel Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/funnel/',
  },
  fashionCupFunnelReport: {
    title: 'Fashion Cup Funnel Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/funnel/',
  },
  solitaireStoryFunnelReport: {
    title: 'Solitaire Story Funnel Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/funnel/',
  },
  manorCafeKPISummary: {
    title: 'Manor Cafe KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/kpisummary',
  },
  cafelandMobileKPISummary: {
    title: 'Cafeland Mobile KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/kpisummary',
  },
  adventureBayKPISummary: {
    title: 'Adventure Bay KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/adv/all/reports/kpisummary',
  },
  cookingTaleKPISummary: {
    title: 'Cooking Tale KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/kpisummary',
  },
  fashionCupKPISummary: {
    title: 'Fashion Cup KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/kpisummary',
  },
  solitaireStoryKPISummary: {
    title: 'Solitaire Story KPI Summary',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/kpisummary',
  },
  manorCafeKPISummaryGraphs: {
    title: 'Manor Cafe KPI Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/kpisummarygraph',
  },
  cafelandMobileKPISummaryGraphs: {
    title: 'Cafeland Mobile KPI Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/kpisummarygraph',
  },
  cookingTaleKPISummaryGraphs: {
    title: 'Cooking Tale KPI Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/kpisummarygraph',
  },
  fashionCupKPISummaryGraphs: {
    title: 'Fashion Cup KPI Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/kpisummarygraph',
  },
  solitaireStoryKPISummaryGraphs: {
    title: 'Solitaire Story KPI Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/kpisummarygraph',
  },
  manorCafeLevelChurnReport: {
    title: 'Manor Cafe Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/levelchurn',
  },
  cafelandMobileLevelChurnReport: {
    title: 'Cafeland Mobile Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/levelchurn',
  },
  adventureBayLevelChurnReport: {
    title: 'Adventure Bay Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/adv/all/reports/levelchurn',
  },
  cookingTaleLevelChurnReport: {
    title: 'Cooking Tale Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/levelchurn',
  },
  fashionCupLevelChurnReport: {
    title: 'Fashion Cup Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/levelchurn',
  },
  solitaireStoryLevelChurnReport: {
    title: 'Solitaire Story Level Churn Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/levelchurn',
  },
  manorCafeLevelPerformanceReport: {
    title: 'Manor Cafe Level Performance Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/level',
  },
  cafelandMobileLevelPerformanceReport: {
    title: 'Cafeland Mobile Level Performance Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/level',
  },
  cookingTaleLevelPerformanceReport: {
    title: 'Cooking Tale Level Performance Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/level',
  },
  fashionCupLevelPerformanceReport: {
    title: 'Fashion Cup Level Performance Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/level',
  },
  solitaireStoryLevelPerformanceReport: {
    title: 'Solitaire Story Level Performance Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/level',
  },
  manorCafeLevelProgressReport: {
    title: 'Manor Cafe Level Progress Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/levelprogress',
  },
  cafelandMobileLevelProgressReport: {
    title: 'Cafeland Mobile Level Progress Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/levelprogress',
  },
  cookingTaleLevelProgressReport: {
    title: 'Cooking Tale Level Progress Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/levelprogress',
  },
  fashionCupLevelProgressReport: {
    title: 'Fashion Cup Level Progress Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/levelprogress',
  },
  solitaireStoryLevelProgressReport: {
    title: 'Solitaire Story Level Progress Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/levelprogress',
  },
  manorCafePanelLiveSummary: {
    title: 'Manor Cafe Live Summary (Panel)',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/livesummary',
  },
  cafelandMobilePanelLiveSummary: {
    title: 'Cafeland Mobile Live Summary (Panel)',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/livesummary',
  },
  adventureBayPanelLiveSummary: {
    title: 'Adventure Bay Live Summary (Panel)',
    link: 'https://panel.gamegos.net/#/apps/adv/all/reports/livesummary',
  },
  cookingTaleLiveSummary: {
    title: 'Cooking Tale Live Summary',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/livesummary',
  },
  fashionCupLiveSummary: {
    title: 'Fashion Cup Live Summary',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/livesummary',
  },
  solitaireStoryLiveSummary: {
    title: 'Solitaire Story Live Summary',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/livesummary',
  },
  manorCafeLTVUserReport: {
    title: 'Manor Cafe LTV User Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/ltvuser',
  },
  cafelandMobileLTVUserReport: {
    title: 'Cafeland Mobile LTV User Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/ltvuser',
  },
  cookingTaleLTVUserReport: {
    title: 'Cooking Tale LTV User Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/ltvuser',
  },
  fashionCupLTVUserReport: {
    title: 'Fashion Cup LTV User Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/ltvuser',
  },
  solitaireStoryLTVUserReport: {
    title: 'Solitaire Story LTV User Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/ltvuser',
  },
  manorCafePanelLTVSummaryReport: {
    title: 'Manor Cafe LTV Summary Report (Panel)',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/ltvsummary',
  },
  cafelandMobilePanelLTVSummaryReport: {
    title: 'Cafeland Mobile LTV Summary Report (Panel)',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/ltvsummary',
  },
  adventureBayPanelLTVSummaryReport: {
    title: 'Adventure Bay LTV Summary Report (Panel)',
    link: 'https://panel.gamegos.net/#/apps/adv/all/reports/ltvsummary',
  },
  cookingTaleLTVSummaryReport: {
    title: 'Cooking Tale LTV Summary Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/ltvsummary',
  },
  fashionCupLTVSummaryReport: {
    title: 'Fashion Cup LTV Summary Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/ltvsummary',
  },
  solitaireStoryLTVSummaryReport: {
    title: 'Solitaire Story LTV Summary Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/ltvsummary',
  },
  manorCafeLTVSummaryGraphs: {
    title: 'Manor Cafe LTV Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/ltvsummarygraph',
  },
  cafelandMobileLTVSummaryGraphs: {
    title: 'Cafeland Mobile LTV Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/ltvsummarygraph',
  },
  cookingTaleLTVSummaryGraphs: {
    title: 'Cooking Tale LTV Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/ltvsummarygraph',
  },
  fashionCupLTVSummaryGraphs: {
    title: 'Fashion Cup LTV Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/ltvsummarygraph',
  },
  solitaireStoryLTVSummaryGraphs: {
    title: 'Solitaire Story LTV Summary Graphs',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/ltvsummarygraph',
  },
  manorCafeMarketingReport: {
    title: 'Manor Cafe Marketing Report',
    link: 'https://panel.gamegos.net/#/apps/man/all/reports/marketing',
  },
  cafelandMobileMarketingReport: {
    title: 'Cafeland Mobile Marketing Report',
    link: 'https://panel.gamegos.net/#/apps/cal/all/reports/marketing',
  },
  cookingTaleMarketingReport: {
    title: 'Cooking Tale Marketing Report',
    link: 'https://panel.gamegos.net/#/apps/coo/all/reports/marketing',
  },
  fashionCupMarketingReport: {
    title: 'Fashion Cup Marketing Report',
    link: 'https://panel.gamegos.net/#/apps/fah/all/reports/marketing',
  },
  solitaireStoryMarketingReport: {
    title: 'Solitaire Story Marketing Report',
    link: 'https://panel.gamegos.net/#/apps/sol/all/reports/marketing',
  },
  manorCafeLoadingAndroidKibana: {
    title: 'Manor Cafe Android Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/f934f1c88f91037eb22c1397965000d0`,
  },
  manorCafeLoadingIosKibana: {
    title: 'Manor Cafe IOS Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/5b057a44ea71c83fac971846319a4868`,
  },
  cafelandMobileLoadingAndroidKibana: {
    title: 'Cafeland Mobile Android Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/dbde508423581bfdbd7b93be01caf90f`,
  },
  cafelandMobileLoadingIosKibana: {
    title: 'Cafeland Mobile IOS Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/f338de95d12f2478952cd4f9899dbd22`,
  },
  adventureBayLoadingAndroidKibana: {
    title: 'Adventure Bay Android Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/b7edb1a16c21c27ad2cedda636d87769`,
  },
  adventureBayLoadingIosKibana: {
    title: 'Adventure Bay IOS Loading Stats',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/70769fe4099a52f4b2b9629ae5689626`,
  },
  jigsawUniquePlayerCountKibana:{
    title: 'Jigsaw Unique Player Count',
    keywords: ['kibana'],
    link: `https://gamedev-logs.gamegos.net/_dashboards/goto/1fcf450229a5dff1f9faaaec8d961ec8`,
  },
  jira: {
    title: 'Jira',
    link: 'https://gamegos.atlassian.net',
    keywords: ['issue'],
  },
  deviceListDoc: {
    title: 'Device List',
    link: 'https://docs.google.com/spreadsheets/d/1a68T1fZ1CpHRRQeaUA8qvngowTglmx_de3idYUlUxeE/edit#gid=0',
    keywords: ['cihaz', 'liste', 'active'],
  },
  analyticsLogs: {
    title: 'Analytics Logs',
    keywords: ['logs', 'kibana'],
    link: 'https://analytics-logs.gamegos.net/_dashboards/app/discover',
  },
  gameDeveloperLogs: {
    title: 'Game Developer Logs',
    keywords: ['logs', 'kibana'],
    link: 'https://gamedev-logs.gamegos.net/_dashboards/app/home#/',
  },
  serviceLogs: {
    title: 'Service Logs',
    keywords: ['logs', 'kibana'],
    link: 'https://service-logs.gamegos.net/_dashboards/app/home#/',
  },
  serviceLogsBeta: {
    title: 'Service Logs - Beta',
    keywords: ['logs', 'kibana'],
    link: 'https://service-logs-beta.gamegos.net/_dashboards/app/home#/',
  },
  googleCalendar: {
    title: 'Google Calendar',
    link: 'https://calendar.google.com/calendar/b/1/r',
    keywords: ['meeting', 'toplantı', 'oda'],
  },
  gamegosHome: {
    title: 'Gamegos Home',
    link: 'https://www.gamegos.com/',
  },
  apiSpecsGamegos: {
    title: 'GAMEGOS API Specs',
    link: 'https://api-specs.liveops.gamegos.net/',
    keywords: ['swagger', 'references', 'api'],
  },
  marketingReport: {
    title: 'Marketing Report',
    link: 'https://panel.gamegos.net/#/marketing/report',
  },
  reportsApp: {
    title: 'Reports App',
    link: 'https://reports.gamegos.net/',
  },
  reportsAppBeta: {
    title: 'Reports App Beta',
    link: 'https://reports-beta.gamegos.net/',
  },
  manorCafeAnalytics: {
    title: 'Manor Cafe Analytics',
    link: 'https://reports.gamegos.net/man/dashboard',
  },
  manorCafeLast12MonthsAnalytics: {
    title: 'Manor Cafe Last 12 Months Dashbord',
    link: 'https://reports.gamegos.net/man/dashboard-12-months',
  },
  cafelandMobileAnalytics: {
    title: 'Cafeland Mobile Analytics',
    link: 'https://reports.gamegos.net/cal/dashboard',
  },
  cafelandMobileLast12MonthsAnalytics: {
    title: 'Cafeland Mobile Last 12 Months Dashbord',
    link: 'https://reports.gamegos.net/cal/dashboard-12-months',
  },
  adventureBayAnalytics: {
    title: 'Adventure Bay Analytics',
    link: 'https://reports.gamegos.net/adv/dashboard',
  },
  adventureBayLast12MonthsAnalytics: {
    title: 'Adventure Bay Last 12 Months Dashbord',
    link: 'https://reports.gamegos.net/adv/dashboard-12-months',
  },
  videoJigsawPuzzleAnalytics: {
    title: 'Video Jigsaw Analytics',
    link: 'https://reports.gamegos.net/vjs/dashboard',
  },
  videoJigsawPuzzleLast12MonthsAnalytics: {
    title: 'Video Jigsaw Last 12 Months Dashbord',
    link: 'https://reports.gamegos.net/vjs/dashboard-12-months',
  },
  puzzlePaintAnalytics: {
    title: 'Puzzle Paint Analytics',
    link: 'https://reports.gamegos.net/pzp/dashboard',
  },
  puzzlePaintLast12MonthsAnalytics: {
    title: 'Puzzle Paint Last 12 Months Dashbord',
    link: 'https://reports.gamegos.net/pzp/dashboard-12-months',
  },
  manorCafeAppsFlyerLTVRetentionReports: {
    title: 'Manor Cafe AppsFlyer LTV & Retention Reports',
    link: 'https://reports.gamegos.net/man/cohort/appsflyer-ltv-retention',
  },
  cafelandMobileAppsFlyerLTVRetentionReports: {
    title: 'Cafeland Mobile AppsFlyer LTV & Retention Reports',
    link: 'https://reports.gamegos.net/cal/cohort/appsflyer-ltv-retention',
  },
  adventureBayAppsFlyerLTVRetentionReports: {
    title: 'Adventure Bay AppsFlyer LTV & Retention Reports',
    link: 'https://reports.gamegos.net/adv/cohort/appsflyer-ltv-retention',
  },
  videoJigsawPuzzleAppsFlyerLTVRetentionReports: {
    title: 'Video Jigsaw AppsFlyer LTV & Retention Reports',
    link: 'https://reports.gamegos.net/vjs/cohort/appsflyer-ltv-retention',
  },
  puzzlePaintAppsFlyerLTVRetentionReports: {
    title: 'Puzzle Paint AppsFlyer LTV & Retention Reports',
    link: 'https://reports.gamegos.net/pzp/cohort/appsflyer-ltv-retention',
  },
  videoJigsawPuzzleLTVPrediction: {
    title: 'Video Jigsaw LTV Prediction',
    link: 'https://reports.gamegos.net/vjs/ltv-prediction',
  },
  manorCafeActivityReport: {
    title: 'Manor Cafe Activity Report',
    link: 'https://reports.gamegos.net/man/activity-reports',
  },
  cafelandMobileActivityReport: {
    title: 'Cafeland Mobile Activity Report',
    link: 'https://reports.gamegos.net/cal/activity-reports',
  },
  adventureBayActivityReport: {
    title: 'Adventure Bay Activity Report',
    link: 'https://reports.gamegos.net/adv/activity-reports',
  },
  videoJigsawPuzzleActivityReport: {
    title: 'Video Jigsaw Activity Report',
    link: 'https://reports.gamegos.net/vjs/activity-reports',
  },
  puzzlePaintActivityReport: {
    title: 'Puzzle Paint Activity Report',
    link: 'https://reports.gamegos.net/pzp/activity-reports',
  },
  manorCafeMonitoringDashboard: {
    title: 'Manor Cafe Monitoring Dashboard',
    link: 'https://reports.gamegos.net/man/monitoring-dashboard',
  },
  cafelandMobileMonitoringDashboard: {
    title: 'Cafeland Mobile Monitoring Dashboard',
    link: 'https://reports.gamegos.net/cal/monitoring-dashboard',
  },
  adventureBayMonitoringDashboard: {
    title: 'Adventure Bay Monitoring Dashboard',
    link: 'https://reports.gamegos.net/adv/monitoring-dashboard',
  },
  videoJigsawPuzzleMonitoringDashboard: {
    title: 'Video Jigsaw Monitoring Dashboard',
    link: 'https://reports.gamegos.net/vjs/monitoring-dashboard',
  },
  puzzlePaintMonitoringDashboard: {
    title: 'Puzzle Paint Monitoring Dashboard',
    link: 'https://reports.gamegos.net/pzp/monitoring-dashboard',
  },
  puzzlePaintCohortReport: {
    title: 'Puzzle Paint Cohort Report',
    link: 'https://reports.gamegos.net/pzp/cohort/cohort-report',
  },
  puzzlePaintCohortGraph: {
    title: 'Puzzle Paint Cohort Graph',
    link: 'https://reports.gamegos.net/pzp/cohort/cohort-graphs',
  },
  manorCafeCohortReport: {
    title: 'Manor Cafe Cohort Report',
    link: 'https://reports.gamegos.net/man/cohort/cohort-report',
  },
  cafelandMobileCohortReport: {
    title: 'Cafeland Mobile Cohort Report',
    link: 'https://reports.gamegos.net/cal/cohort/cohort-report',
  },
  adventureBayCohortReport: {
    title: 'Adventure Bay Cohort Report',
    link: 'https://reports.gamegos.net/adv/cohort/cohort-report',
  },
  videoJigsawPuzzleCohortReport: {
    title: 'Video Jigsaw Cohort Report',
    link: 'https://reports.gamegos.net/vjs/cohort/cohort-report',
  },
  manorCafeCohortGraph: {
    title: 'Manor Cafe Cohort Graph',
    link: 'https://reports.gamegos.net/man/cohort/cohort-graphs',
  },
  cafelandMobileCohortGraph: {
    title: 'Cafeland Mobile Cohort Graph',
    link: 'https://reports.gamegos.net/cal/cohort/cohort-graphs',
  },
  adventureBayCohortGraph: {
    title: 'Adventure Bay Cohort Graph',
    link: 'https://reports.gamegos.net/adv/cohort/cohort-graphs',
  },
  videoJigsawPuzzleCohortGraph: {
    title: 'Video Jigsaw Cohort Graph',
    link: 'https://reports.gamegos.net/vjs/cohort/cohort-graphs',
  },
  manorCafePVXStatistics: {
    title: 'Manor Cafe PVX Statistics',
    link: 'https://reports.gamegos.net/man/pvx-statistics',
  },
  cafelandMobilePVXStatistics: {
    title: 'Cafeland Mobile PVX Statistics',
    link: 'https://reports.gamegos.net/cal/pvx-statistics',
  },
  adventureBayPVXStatistics: {
    title: 'Adventure Bay PVX Statistics',
    link: 'https://reports.gamegos.net/adv/pvx-statistics',
  },
  videoJigsawPuzzlePVXStatistics: {
    title: 'Video Jigsaw PVX Statistics',
    link: 'https://reports.gamegos.net/vjs/pvx-statistics',
  },
  cafelandMobileMarketingDashboard: {
    title: 'Cafeland Mobile Marketing Dashboard',
    link: 'https://reports.gamegos.net/cal/marketing-dashboard',
  },
  manorCafeMarketingDashboard: {
    title: 'Manor Cafe Marketing Dashboard',
    link: 'https://reports.gamegos.net/man/marketing-dashboard',
  },
  adventureBayMarketingDashboard: {
    title: 'Adventure Bay Marketing Dashboard',
    link: 'https://reports.gamegos.net/adv/marketing-dashboard',
  },
  puzzlePaintMarketingDashboard: {
    title: 'Puzzle Paint Marketing Dashboard',
    link: 'https://reports.gamegos.net/pzp/marketing-dashboard',
  },
  videoJigsawPuzzleMarketingDashboard: {
    title: 'Video Jigsaw Marketing Dashboard',
    link: 'https://reports.gamegos.net/vjs/marketing-dashboard',
  },
  cafelandMobileGoogleSites: {
    title: 'Cafeland Mobile Google Sites',
    link: 'https://sites.google.com/gamegos.com/cafelandmobile/home',
  },
  manorCafeGoogleSites: {
    title: 'Manor Cafe Google Sites',
    link: 'https://sites.google.com/gamegos.com/manorcafe/home',
  },
  adventureBayGoogleSites: {
    title: 'Adventure Bay Google Sites',
    link: 'https://sites.google.com/gamegos.com/adventureisland/home',
  },

  // Backend Services
  composerSatisSvc: {
    title: 'Composer Satis Service',
    link: 'https://satis.devops.gamegos.net',
  },
  jiraBoardApp: {
    title: 'Jira Board App',
    link: 'https://jira-board.backend.gamegos.net',
  },
};
